import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import Button from '../Button';
import ButtonContainer from './ButtonContainer';
import StyledSubmitButton from './StyledButton';

export type ShowPhoneSubmitButtonProps = {
  onSubmit: () => void;
  onClose: () => void;
};

const ShowPhoneSubmitButton: React.FC<ShowPhoneSubmitButtonProps> = ({
  onSubmit,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation(['property', 'common']);
  const buttonText = t('showPhone');
  const cancel = t('cancel', { ns: 'common' });

  const state = useSelector(
    (state: RootState) => ({
      isShowPhoneButtonLoading: state.contactForm.isShowPhoneButtonLoading,
      isShowPhoneFormSent: state.contactForm.isShowPhoneFormSent
    }),
    shallowEqual
  );

  return (
    <ButtonContainer {...rest}>
      <StyledSubmitButton
        fullWidth
        onClick={onSubmit}
        type='submit'
        loading={state.isShowPhoneButtonLoading}
        color='midnight'
        disabled={state.isShowPhoneFormSent || state.isShowPhoneButtonLoading}
      >
        {buttonText}
      </StyledSubmitButton>
      <Button
        fullWidth
        onClick={onClose}
        type='button'
        color='secondary'
        variant='outlined'
      >
        {cancel}
      </Button>
    </ButtonContainer>
  );
};

export default ShowPhoneSubmitButton;
